import { idleState, uninitState, failedState, successState, loadingState, statusSuccess } from "@grandvisionhq/state";
import { UPDATE_USER_DATA_FAILED, UPDATE_USER_DATA_SUCCESS, UPDATE_USER_DATA, FETCH_USER_DATA_SUCCESS, FETCH_USER_DATA_FAILED, FETCH_USER_DATA } from "./actions.js";
const initialState = {
  userData: uninitState(),
  updateCalls: {
    personalDetails: idleState(),
    billingAddress: idleState(),
    preferredStore: idleState()
  }
};
function userDataReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_DATA:
      return {
        ...state,
        userData: loadingState()
      };
    case FETCH_USER_DATA_FAILED:
      return {
        ...state,
        userData: failedState(action.error)
      };
    case FETCH_USER_DATA_SUCCESS:
      let updateUserData;
      if (state.userData && statusSuccess(state.userData)) {
        updateUserData = {
          ...state.userData.result,
          ...action.payload
        };
      } else {
        updateUserData = action.payload;
      }
      return {
        ...state,
        userData: successState(updateUserData)
      };
    case UPDATE_USER_DATA:
      return {
        ...state,
        updateCalls: {
          ...state.updateCalls,
          [action.payload.formName]: loadingState()
        }
      };
    case UPDATE_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: successState(action.payload.server),
        updateCalls: {
          ...state.updateCalls,
          [action.payload.formName]: idleState()
        }
      };
    case UPDATE_USER_DATA_FAILED:
      return {
        ...state,
        updateCalls: {
          ...state.updateCalls,
          [action.payload.formName]: failedState(action.payload.error)
        }
      };
    default:
      return state;
  }
}
export {
  initialState,
  userDataReducer
};
//# sourceMappingURL=reducer.js.map
